import * as React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Event, Location, LocationTrackingSchedule } from 'cb-model';
import {
  Display,
  IsAllowed,
  List,
  NavIconContainer,
  PageTitle,
  QueryMulti,
  QuerySingle,
  Section,
  useCacheQuery,
} from 'gossamer-front-end';
import { getFilter, QueryOptions } from 'gossamer-unified';
import { Button } from 'react-bootstrap';

/**
 * Location Display Page
 *
 * Display details for a single location
 */
export const LocationDisplay = (): React.JSX.Element => {
  const params = useParams();

  // Query for tracking schedules at this location
  const [queryOptions, setQueryOptions] = React.useState({
    where: { and: [getFilter('location_id', 'eq', params.key, 'hidden')] },
    order: LocationTrackingSchedule.defaultSort,
  } as QueryOptions);
  const gCacheQueryItem = useCacheQuery(LocationTrackingSchedule, queryOptions);

  return (
    <>
      <NavIconContainer entityId={Location.id} />
      <PageTitle verb="Display" entity={Location} keyValue={params.key} />
      <Section>
        <QuerySingle entity={Location} keyValue={params.key} render={Display} />
        <IsAllowed entity={Location} action="update">
          <div className="d-flex gap-2">
            <Link to={`/admin/location/update/${params.key}`}>
              <Button size="sm" variant="primary">
                Update
              </Button>
            </Link>
            <Link to={`/admin/location/set-coordinates/${params.key}`}>
              <Button size="sm" variant="success">
                📍 Set Coordinates
              </Button>
            </Link>
          </div>
        </IsAllowed>
      </Section>

      <Section title="Events at this Location">
        <QueryMulti
          entity={Event}
          queryOptions={{ where: { and: [getFilter('gps_location', 'eq', params.key)] }, order: Event.defaultSort }}
          render={List}
        />
      </Section>

      {/* <Section title="Tracking Schedules">
        <div>
          <Link to={`/admin/location-tracking-schedule/create?location_id=${params.key}`}>
            <Button size="sm" variant="primary">
              Create a new Tracking Schedule
            </Button>
          </Link>
        </div>
        <br />

        <PaginatorAndListSettings
          entity={LocationTrackingSchedule}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section> */}
    </>
  );
};
